import axios from "./axios";
export default class AccountService {
  static forgotPassword(email) {
    return axios.post("Account/forgotpassword", { email }).then((response) => response.data);
  }

  static forgotPasswordValidate(email, token) {
    return axios.post("Account/forgotpasswordvalidate", { email, token }).then((response) => response.data);
  }

  static resetPassword(id, token, password, confirmPassword) {
    return axios.post("Account/resetpassword", { id, token, password, confirmPassword }).then((response) => response.data);
  }

  static changePassword(password, newPassword, confirmNewPassword) {
    return axios.post("Account/changePassword", { password, newPassword, confirmNewPassword }).then((response) => response.data);
  }

  static confirmAccount(userId, code) {
    return axios
      .get("Account/confirm", { params: { UserId: userId, Code: code } })
      .then((response) => response.data);
  }

  static userInfo() {
    return axios.get("Account").then((response) => response.data);
  }
}
